var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIndiaFlag = function SvgIndiaFlag(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 10,
    fill: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "FINAL - TOI - Revised Landing Page"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-436 -678C-436 -679.105 -435.105 -680 -434 -680H1883C1884.1 -680 1885 -679.105 1885 -678V983C1885 984.104 1884.1 985 1883 985H-434C-435.105 985 -436 984.105 -436 983V-678Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-434 -680V-679H1883V-680V-681H-434V-680ZM1885 -678H1884V983H1885H1886V-678H1885ZM1883 985V984H-434V985V986H1883V985ZM-436 983H-435V-678H-436H-437V983H-436ZM-434 985V984C-434.552 984 -435 983.552 -435 983H-436H-437C-437 984.657 -435.657 986 -434 986V985ZM1885 983H1884C1884 983.552 1883.55 984 1883 984V985V986C1884.66 986 1886 984.657 1886 983H1885ZM1883 -680V-679C1883.55 -679 1884 -678.552 1884 -678H1885H1886C1886 -679.657 1884.66 -681 1883 -681V-680ZM-434 -680V-681C-435.657 -681 -437 -679.657 -437 -678H-436H-435C-435 -678.552 -434.552 -679 -434 -679V-680Z",
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "TOI Landing Page"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 812,
    transform: "translate(-274 -511)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1597883144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1597883155"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -250,
    y: -220,
    width: 327,
    height: 296,
    rx: 16,
    fill: "url(#paint0_linear_3839_1851)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -249.5,
    y: -219.5,
    width: 326,
    height: 295,
    rx: 15.5,
    stroke: "url(#paint1_linear_3839_1851)",
    strokeOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "block"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -229.75,
    y: -19.75,
    width: 286.5,
    height: 75.5,
    rx: 9.75,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -229.75,
    y: -19.75,
    width: 286.5,
    height: 75.5,
    rx: 9.75,
    stroke: "#ECEAEA",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1597883764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1597883762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IN"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    x: 0.0972222,
    y: 0.0972222,
    width: 13.8056,
    height: 9.80556,
    rx: 0.680556,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.194444
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3839_1851",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 10
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Mask_2",
    x: 0.0972222,
    y: 0.0972222,
    width: 13.8056,
    height: 9.80556,
    rx: 0.680556,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.194444
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3839_1851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.33333H14V0H0V3.33333Z",
    fill: "#FFA44A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.0013H14V6.66797H0V10.0013Z",
    fill: "#1A9F0B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval 1",
    cx: 7,
    cy: 5,
    r: 1.12963,
    fill: "#181A93",
    fillOpacity: 0.15,
    stroke: "#181A93",
    strokeWidth: 0.259259
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval 8",
    cx: 6.99935,
    cy: 4.99935,
    r: 0.333333,
    fill: "#181A93"
  })))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3839_1851",
    x1: -86.5,
    y1: -220,
    x2: -86.5,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF3F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3839_1851",
    x1: -250,
    y1: -72,
    x2: 77,
    y2: -72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6E64"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIndiaFlag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/india-flag.29981c292c153e32ba8070e8fe3c8a15.svg";